<template>
  <div class="main">
    <div class="header">
      <div class="logo" @click="goIndex('index')">
        <img src="../../assets/images/logo.png" alt="logo" style="width: 60%; height: 60%; margin-right: 10px;">
        营销平台
      </div>
      <div class="nav-body">
        <div :class="['nav ' + (index === currentIndex ? 'selectcd' : '')]" v-for="(item, index) in navData" :key="index" @click="showComponents(index)"><i :class="item.icon"></i>{{ item.title }}</div>
      </div>
      <div class="right">
        <el-dropdown style="float: right;">
          <span class="header-btn">
            {{ user_name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="showComponents(3)"><i style="padding-right: 8px" class="fa fa-cog"></i>个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="logout"><i style="padding-right: 8px" class="fa fa-key"></i>退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="app">
      <div class="aside">
        <div class="menu"></div>
      </div>
      <div class="app-body">
        <div id="mainContainer" class="main-container" v-loading="true" element-loading-text="loading..." element-loading-background="#FFFFFF">
          <div class="layout-right jm-animate">
            <el-scrollbar style="height: 100%;">
              <component :is="current" @jump_plan="showComponents(1)"></component>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  /* global require */
  data() {
    return {
      adminInfo: [],
      current: 'HomeView',
      currentIndex: 0,
      user_name: '',
      navData: [
        {
          title: '首页推广',
          components: 'HomeView',
          icon: 'fa fa-home'
        },
        {
          title: '推广中心',
          components: 'PlanView',
          icon: 'fa fa-bell-o'
        },
        {
          title: '数据中心',
          components: 'DataView',
          icon: 'fa fa-bar-chart'
        },
        {
          title: '受众分析',
          components: 'AddressView',
          icon: 'el-icon-share'
        },
        {
          title: '账户中心',
          components: 'UsersView',
          icon: 'fa fa-user-circle-o'
        }
      ]
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$http.post('/trader/index/getUserInfo').then(res => {
        if (res.code === 200 && res.data.user_name !== undefined) {
          sessionStorage.setItem('user_info', JSON.stringify(res.data));
          this.user_name = res.data.user_name;
        } else {
          this.$message.error('未找到该用户，请联系管理员');
          this.logout();
        }
      });
    },
    showComponents(index) {
      if (this.current !== this.navData[index].components) {
        this.$function.showLoading();
        this.currentIndex = index;
        this.current = this.navData[index].components;
      }
    },
    logout() {
      sessionStorage.removeItem(this.$Config.tokenKey);
      this.$router.push({ path: '/login' });
    }
  },
  mounted() {

  },
  components: {
    HomeView: resolve => require(['@/views/Index/Lists.vue'], resolve),
    PlanView: resolve => require(['@/views/Plan/Lists.vue'], resolve),
    UsersView: resolve => require(['@/views/Users/Lists.vue'], resolve),
    AddressView: resolve => require(['@/views/Address/Lists.vue'], resolve),
    DataView: resolve => require(['@/views/Data/Lists.vue'], resolve)
  }
};
</script>
<style lang="less">
@import '../../assets/css/style.less';
@header-bg: #ffffff;

.el-menu-item .is-active {
  background-color: #3e85e9 !important;
}

.nav {
  width: 150px;
  height: 65px;
  line-height: 65px;
  color: #29333D;
  text-align: center;
  font-size: 15px;
  i {
    font-size: 16px;
    margin-right: 5px;
  }
}

.nav:hover {
  cursor: pointer;
  color: #0056AF;
  background: #fff;
}

.selectcd {
  color: #0056AF;
  background: #fff;
}

.el-menu-item:focus,
.el-menu-item:hover,
.el-submenu__title:hover {
  background-color: #FFF !important;
}

.main {
  display: flex;
  .el-menu:not(.el-menu--collapse) {
    width: 230px;
  }
  .app {
    width: 100%;
    background: #F7F8F8;
  }
  .aside {
    position: fixed;
    margin-top: 50px;
    z-index: 10;
    background-color: #F7F8F8;
    transition: all 0.3s ease-in-out;
    .menu {
      overflow-y: auto;
      height: calc(100vh);
    }
  }
  .app-body {
    margin-left: 5%;
    -webkit-transition: margin-left 0.3s ease-in-out;
    transition: margin-left 0.3s ease-in-out;
  }
  .main-container {
    width: 95%;
    // width: 100%;
    height: calc(100vh - 65px);
    background: #FFFFFF;
    overflow-y: auto;
    position: relative;
    margin-top: 65px;
  }
}

.header {
  width: 100%;
  position: fixed;
  display: flex;
  height: 65px;
  background-color: @header-bg;
  box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 10;
  .logo {
    width: 230px;
    height: 65px;
    overflow: hidden;
    line-height: 50px;
    color: #166D9F;
    background-color: #ffffff;
    -webkit-transition: width 0.35s;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    .min {
      display: none;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .nav-body {
    width: calc(100% - 460px);
    display: flex;
    div {
      margin-right: 35.5px;
    }
  }
  .right {
    position: absolute;
    right: 0;
    width: 230px;
  }
  .header-btn {
    overflow: hidden;
    height: 65px;
    display: inline-block;
    text-align: center;
    line-height: 65px;
    cursor: pointer;
    padding: 0 14px;
    .el-badge__content {
      top: 14px;
      right: 7px;
      text-align: center;
      font-size: 9px;
      padding: 0 3px;
      background-color: #00a65a;
      color: #fff;
      border: none;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25em;
    }
  }
  .header-btn:hover {
    background-color: @header-bg;
  }
}
.menu {
  border-right: none;
}
.el-menu--vertical {
  min-width: 190px;
}
</style>
